export const STORY_ROUTE_SLUGS = {
  batya: 'batya',
  unheard: 'unheard',
  Tour: 'tour',
  the_ticket: 'the-ticket',
  accidental_witness: 'accidental-witness',
  falling_skies: 'falling-skies',
  the_labyrinth: 'labyrinth',
  they_are_already_here: 'they-are-already-here',
  blue_fire: 'blue-flame',
};

export const getStoryRouteSlug = (chapter) => {
  if (!chapter) return '';
  return chapter.slug || STORY_ROUTE_SLUGS[chapter.id] || String(chapter.id || '').toLowerCase();
};

export const findStoryChapterBySlug = (chapters, slug) => {
  const normalizedSlug = String(slug || '').toLowerCase();
  return chapters.find((chapter) => {
    const routeSlug = getStoryRouteSlug(chapter).toLowerCase();
    const legacyId = String(chapter.id || '').toLowerCase();
    return routeSlug === normalizedSlug || legacyId === normalizedSlug;
  });
};
